import {
  Search,
  Download,
  RefreshCw,
  Trash2,
  X,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const STATUS_OPTIONS = [
  { k: "all", label: "All" },
  { k: "contacted", label: "Contacted" },
  { k: "pending", label: "Pending" },
];

export default function LeadsFilterBar({
  q,
  setQ,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  statusFilter,
  setStatusFilter,
  onRefresh,
  onClear,
  onExport,
  onDeleteAll,
  canDelete,
  loading,
  itemsCount,
  total,
}) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
        <div className="md:col-span-4">
          <Label className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
            Search name or mobile
          </Label>
          <div className="mt-2 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <Input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Rahul / 98240…"
              className="pl-9 h-11 bg-white/5 border-white/10 text-white"
              data-testid="leads-search-input"
            />
          </div>
        </div>
        <div className="md:col-span-2">
          <Label className="text-[11px] uppercase tracking-[0.18em] text-slate-400">From</Label>
          <Input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            className="mt-2 h-11 bg-white/5 border-white/10 text-white"
            data-testid="leads-date-from"
          />
        </div>
        <div className="md:col-span-2">
          <Label className="text-[11px] uppercase tracking-[0.18em] text-slate-400">To</Label>
          <Input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className="mt-2 h-11 bg-white/5 border-white/10 text-white"
            data-testid="leads-date-to"
          />
        </div>
        <div className="md:col-span-2">
          <Label className="text-[11px] uppercase tracking-[0.18em] text-slate-400">Status</Label>
          <div className="mt-2 grid grid-cols-3 gap-1 bg-white/5 border border-white/10 rounded-md p-1">
            {STATUS_OPTIONS.map((s) => (
              <button
                key={s.k}
                type="button"
                onClick={() => setStatusFilter(s.k)}
                className={`h-9 rounded text-xs font-medium transition-colors ${
                  statusFilter === s.k
                    ? "bg-[#F97316] text-white"
                    : "text-slate-300 hover:bg-white/5"
                }`}
                data-testid={`leads-status-${s.k}`}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
        <div className="md:col-span-2 flex gap-2">
          <Button
            onClick={onRefresh}
            variant="outline"
            className="flex-1 h-11 border-white/15 bg-transparent hover:bg-white/5 text-white"
            data-testid="leads-refresh-btn"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Refresh
          </Button>
          <Button
            onClick={onClear}
            variant="ghost"
            className="h-11 px-3 text-slate-400 hover:text-white hover:bg-white/5"
            data-testid="leads-clear-btn"
            title="Clear filters"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="text-xs text-slate-500">
          {loading ? "Loading…" : `${itemsCount} shown · ${total} matching`}
        </div>
        <div className="flex items-center gap-2">
          {canDelete && (
            <Button
              onClick={onDeleteAll}
              variant="outline"
              className="border-red-500/40 bg-transparent text-red-400 hover:bg-red-500/10 hover:text-red-300"
              data-testid="leads-delete-all-btn"
              disabled={itemsCount === 0}
              title="Delete all leads matching the current filters"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete filtered
            </Button>
          )}
          <Button
            onClick={onExport}
            className="bg-[#F97316] hover:bg-[#EA580C] text-white"
            data-testid="leads-export-csv-btn"
          >
            <Download className="w-4 h-4 mr-2" />
            Export CSV
          </Button>
        </div>
      </div>
    </>
  );
}
